const currency = (v) => {
  const parsedVal = parseFloat(v);
  return Number.isNaN(parsedVal)
    ? ''
    : parsedVal
        .toLocaleString('en-US', { style: 'currency', currency: 'USD' })
        .replace(/\D\d\d$/, '');
};

const currencyWithDecimals = (v, fractions = 0) => {
  const parsedVal = parseFloat(v);
  return Number.isNaN(parsedVal)
    ? ''
    : parsedVal.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: fractions,
      });
};

const formatNumberWithCommas = (value) => {
  if (
    Number.isNaN(value) ||
    value === false ||
    value === null ||
    value === undefined
  )
    return 0;
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const formatAprValue = (p) => {
  if (p === 0) return 'Use Encompass';
  if (p === null || p === undefined || Number.isNaN(p)) return '--';
  if (p === false) return '0.000%';
  return `${p.toFixed(3)}%`;
};

const formatPercentValue = (p) => {
  if (p === null || p === undefined || Number.isNaN(p)) return '--';
  if (p === false) return '0.000%';
  return `${p.toFixed(3)}%`;
};

const isEmpty = (value) => {
  return (
    value == null ||
    (typeof value === 'object' && Object.keys(value).length === 0) ||
    (typeof value === 'string' && value.trim().length === 0)
  );
};

export {
  currency,
  currencyWithDecimals,
  isEmpty,
  formatNumberWithCommas,
  formatAprValue,
  formatPercentValue,
};
